import React from 'react';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';

import { Box, TextArea } from 'grommet';

import customTheme from 'app/style/theme';

const StyledBox = styled(Box)`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 8;
  height: 175px;
  padding: 11px 11px 80px 11px;
  background: ${customTheme.global.colors['neutral-4']};
`;

const Input = styled(TextArea)`
  resize: none;
  width: 100%;
  height: 100%;
  background: ${customTheme.global.colors['accent-2']};
`;

function onSubmit(AppState, keypress) {
  if (keypress === 'Enter') {
    AppState.bookmarks.insert({
      path: AppState.bookmarkingSelectionPath.slice(),
      content: AppState.bookmarkingSelectionContent,
      note: AppState.bookmarkingNote,
    });
    AppState.resetBookmarkingSelection();
    AppState.setMenuBar('MAIN_MENU');
  }
}

function NoteInput({ AppState }) {
  if (!AppState.isUserAnnotating) return null;
  return (
    <StyledBox width="large">
      <Input
        required
        autoFocus
        placeholder="Type note here..."
        value={AppState.bookmarkingNote}
        onChange={event => AppState.newBookmarkingNote(event.target.value)}
        onKeyPress={event => onSubmit(AppState, event.key)}
      />
    </StyledBox>
  );
}

export default inject('AppState')(observer(NoteInput));



// WEBPACK FOOTER //
// ./src/app/components/BookmarkMenu/NoteInput.js